export default __webpack_public_path__ + "static/media/112.07f0b91f.jpeg";